export const iconClasses = [
    {
        linkType : 1,
        icon : "fa-solid fa-calendar-check icon-reserve",
        text : "Reserve a Table"
    },
    {
        linkType : 2,
        icon : "fa-solid fa-utensils icon-menu",
        text : "Menu"
    },
    {
        linkType : 3,
        icon : "fa-solid fa-earth-americas icon-website",
        text : "Website"
    },
    {
        linkType : 6,
        icon : "fa-solid fa-star icon-tripadvisor",
        text : "Trip Advisor"
    },
    {
        linkType : 7,
        icon : "fa-solid fa-map-marker-alt icon-map",
        text : "Google Maps"
    },
    {
        linkType : 9,
        icon : "fa-brands fa-instagram icon-instagram",
        text : "Instagram"
    },
    {
        linkType : 4,
        icon : "fa-solid fa-phone icon-call",
        text : "Call Us"
    },
    {
        linkType : 10,
        icon : "fa-solid fa-earth-americas icon-events",
        text : "Events"
    },
];